import React from "react"
import { Map, Base, Circle, Marker, Label, InfoWindow } from "rc-bmap"

import "./bmap.css"

import logoPng from "../images/logo.png"
import iconAddressPng from "../images/contact/icon-address.png"

const { Point, Size } = Base
const { Content } = Label

const BMap = ({ lng = 116.34282, lat = 39.90366 }) => {
  return (
    <Map ak="Dt1IixFePF8Sglc5YoMdRWVarLZCBdvt" zoom={17}>
      <Point name="center" lng={lng} lat={lat} />
      <Circle
        strokeColor="blue"
        fillColor="blue"
        radius={120}
        strokeWeight={1}
        strokeOpacity={0.5}
        fillOpacity={0.1}
      >
        <Point name="center" lng={lng} lat={lat - 0.0006} />
      </Circle>
      <Marker>
        <Point lng={lng} lat={lat} />
      </Marker>
      <InfoWindow visible={true} height={90} width={300}>
        <Size name="offset" width={-6} height={-24} />
        <Point lng={lng} lat={lat} />
        <Content>
          <div className="mapContent">
            <div className="addressWrap">
              <img src={iconAddressPng} alt="" className="addressIcon" />
            </div>
            <div className="mapInfo">
              <img src={logoPng} alt="logo" className="logoImg" />
              <p>北京市海淀区羊坊店街道小马厂华天大厦1418室</p>
              <p>TEL：010-8260110 或 010-63282880</p>
            </div>
          </div>
        </Content>
      </InfoWindow>
    </Map>
  )
}

export default BMap
